import { Component, OnInit, Input } from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {PatientService} from '../../services/patient.service';
import {UserService} from '../../services/user.service';
// Import wprost z pliku, nie z barrela: ModalService (eksportowany przez `../../services`)
// importuje ten komponent, więc przez barrel powstałby cykl zależności.
import {ConfirmationService} from '../../services/confirmation.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-form-modal',
  templateUrl: './form-modal.component.html',
  styleUrls: ['./form-modal.component.scss']
})
export class FormModalComponent implements OnInit {

    @Input()id: number;
    myForm: FormGroup;
    user = [];

  constructor(
      public activeModal: NgbActiveModal,
      private formBuilder: FormBuilder,
      private patientService: PatientService,
      private userService: UserService,
      private translate: TranslateService,
      private confirmation: ConfirmationService,
  ) {
  }

  ngOnInit() {
      this.createForm();
      this.patientService.getUserContact().subscribe(
          data => {
              this.user = data.data;
              const mail_html = <HTMLInputElement>document.getElementById('mail');
              const phone_html = <HTMLInputElement>document.getElementById('phone');

              if(this.user['phone'])
              phone_html.value =  this.user['phone'];
          }
      );
  }

    closeModal() {
        this.activeModal.close('Modal Closed');
    }

    private createForm() {
        this.myForm = this.formBuilder.group({
            mail: [null, [Validators.required]],
            phone: [null, [Validators.required, Validators.minLength(9)]],
            problem: 'pomoctechniczna',
            contact: 'telefon'
        });
    }

    submitForm() {
        this.activeModal.close(this.myForm.value);
    }

    sendForm() {
      const mail_html = <HTMLInputElement>document.getElementById('mail');
      const phone_html = <HTMLInputElement>document.getElementById('phone');

      let mail_now = mail_html.value;
      let phone_now = phone_html.value;

      if (!mail_now) mail_now = this.translate.instant('COMMON.NO_EMAIL_PROVIDED');
      if (!phone_now) phone_now = this.translate.instant('COMMON.NO_PHONE_PROVIDED');
      this.confirmation.show('BACKEND.CONFIRM-OF-SEND-FORM');
      this.patientService.formContact(mail_now, phone_now,this.myForm.get('problem').value,this.myForm.get('contact').value).subscribe(
          data => {
          },
      );
    }


}
